<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" style="opacity: 0.9" fluid>
        <v-snackbar
          v-model="snackbar.show"
          bottom
          content-class="text-center"
          :color="snackbar.color"
          elevation="24"
        >
          {{ snackbar.message }}
        </v-snackbar>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6">
            <v-card class="elevation-12">
              <v-toolbar color="primary" flat>
                <v-toolbar-title>Profile Settings</v-toolbar-title>
              </v-toolbar>
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                bottom
                color="white"
              ></v-progress-linear>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Current Password"
                    prepend-icon="mdi-form-textbox-password"
                    type="password"
                    v-model="currentPassword"
                    aria-required="true"
                  ></v-text-field>
                  <v-text-field
                    label="New Password"
                    prepend-icon="mdi-form-textbox-password"
                    type="password"
                    v-model="newPassword"
                    aria-required="true"
                  ></v-text-field>
                  <v-text-field
                    label="Confirm New Password"
                    prepend-icon="mdi-form-textbox-password"
                    type="password"
                    v-model="confirmNewPassword"
                    aria-required="true"
                    @keyup.enter="changePassword"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="changePassword" color="primary">
                  Change Password
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data() {
      return {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        snackbar: {
          show: false,
          color: 'primary',
          message: ''
        },
        loading: false
      }
    },
    methods: {
      async changePassword() {
        this.loading = true

        if (this.newPassword !== this.confirmNewPassword) {
          console.log('password do not match')
          this.showSnackbar('red', 'New passwords do not match!')
          this.loading = false
          return
        }

        const user = firebase.auth().currentUser
        const credentials = firebase.auth.EmailAuthProvider.credential(
          user.email,
          this.currentPassword
        )

        try {
          await user.reauthenticateWithCredential(credentials)
          await user.updatePassword(this.newPassword)
          this.showSnackbar('green', 'Password successfully changed!')
        } catch (error) {
          this.showSnackbar('red', 'An error occurred. Please try again!')
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      showSnackbar(type, message) {
        this.snackbar.color = type
        this.snackbar.message = message
        this.snackbar.show = true
      }
    }
  }
</script>
